import { useMutation } from "@tanstack/react-query";
import { useServices } from "@/app/use-services";
import { leaveFor } from "@/lib/navigation";
import { Button } from "@/ui/Button";
import { ErrorNote } from "@/ui/Field";
import { Tiny } from "@/ui/Text";
import { billingMessage } from "./billing-message";
import { deviceTimeZone, localAmount, localPrice } from "./price";

const INCLUDED = [
  "Talk to her about anything, up to an hour a month",
  "Type as many questions as you like",
  "Your day, week and month, every day",
  "She remembers what you tell her",
] as const;

/** The one plan: its price, what it includes, and the button that goes to Stripe. */
export function SubscribeOffer() {
  const { api, analytics } = useServices();
  const subscribe = useMutation({
    mutationFn: () => api.startCheckout("monthly"),
    onSuccess: (url) => leaveFor(url),
    onError: () => analytics.track({ name: "checkout failed" }),
  });
  function start() {
    analytics.track({ name: "subscribe tapped", ...localAmount(deviceTimeZone()) });
    subscribe.mutate();
  }

  return (
    <div className="w-full">
      <p className="font-display text-[34px] leading-none">
        {localPrice(deviceTimeZone())}
        <span className="ml-2 font-display text-[18px] text-mid">a month</span>
      </p>
      <Tiny className="mt-2">Cancel any time. You’re charged in your own currency.</Tiny>
      <ul className="mt-5 space-y-2.5 border-y border-rule py-4">
        {INCLUDED.map((item) => (
          <li key={item} className="flex gap-3 text-[16px] leading-[1.4]">
            <span aria-hidden="true" className="font-mono text-[13px] leading-[1.6]">✓</span>
            {item}
          </li>
        ))}
      </ul>
      <div className="mt-6">
        <Button label="Subscribe" onClick={start} busy={subscribe.isPending} />
      </div>
      <ErrorNote message={subscribe.isError ? billingMessage(subscribe.error) : null} />
      <Tiny className="mt-3">Stripe handles the payment. We never see your card.</Tiny>
    </div>
  );
}
